import { Button, Flex, Image, Text, useColorMode } from '@chakra-ui/react'
import { useRouter } from 'next/router'
import React from 'react'
import { isAddress } from 'viem'
import { Routes } from 'constants/routes'
import { useThemeColors } from 'hooks/useThemeColors'
import { isValidNumber, isValidTxHash } from 'utils/common'

const TYPES = {
  bundle: 'Bundle',
  block: 'Block',
  transaction: 'Txn',
  address: 'Address',
} as const

type InvalidDetailProps = {
  type: keyof typeof TYPES
  id: string
}

const getInvalidMessage = (type: keyof typeof TYPES) => {
  let invalidType: string

  switch (type) {
    case 'block':
      invalidType = 'block height'
      break
    case 'transaction':
      invalidType = 'transaction hash'
      break
    case 'address':
      invalidType = 'address'
      break
    case 'bundle':
      invalidType = 'bundle index'
      break
    default:
      invalidType = 'string'
      break
  }

  return `The ${invalidType} you are looking for might be invalid`
}

export const InvalidDetail = ({ type, id, ...props }: InvalidDetailProps) => {
  const COLORS = useThemeColors()
  const { colorMode } = useColorMode()
  const { push } = useRouter()

  const handleRedirect = () => {
    void push(Routes.home())
  }

  const isValidFormat = isAddress(id) || isValidTxHash(id) || isValidNumber(id)

  return (
    <Flex my={{ base: 0, md: 14 }} alignItems="center" flexDir="column" {...props}>
      <Image alt="Transaction not found" src={`/assets/detail_not_found_${colorMode}.svg`} />
      <Text variant="heading4medium" textAlign="center" mt={4}>
        We couldn&apos;t find the {TYPES[type]} you are looking for
      </Text>
      <Text color={COLORS.grey02} mt={4} textAlign="center" wordBreak="break-all">
        {isValidFormat ? id : getInvalidMessage(type)}
      </Text>
      <Button size={{ base: 'small', sm: 'big' }} mt={6} onClick={handleRedirect}>
        Take me home
      </Button>
    </Flex>
  )
}
